/**
 * Moves the glow of the `data-spotlight` panel under the pointer to the pointer's position, by setting the panel's `--spot-x` and
 * `--spot-y`. Attach it once, as `onPointerMove`, to an element that holds the panels.
 *
 * @param event - The pointer event from the element holding the panels.
 */
export function spotlightPointerMove(event: React.PointerEvent): void {
  if (!(event.target instanceof Element)) {
    return;
  }
  const panel = event.target.closest<HTMLElement>("[data-spotlight]");
  if (!panel) {
    return;
  }
  const bounds = panel.getBoundingClientRect();
  panel.style.setProperty("--spot-x", `${String(event.clientX - bounds.left)}px`);
  panel.style.setProperty("--spot-y", `${String(event.clientY - bounds.top)}px`);
}
